import React, { useCallback, useContext, useEffect } from "react";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { UI } from "@wwimmo/ui";
import { useTranslation } from "react-i18next";
import styles from "./ManagerAssemblies.module.css";
import { RootStoreContext } from "src/stores/RootStore";
import { withRouter, RouteComponentProps, useParams } from "react-router";
import { Route, selectRoute } from "src/config/routes";
import { AssembliesList } from "src/screens/assemblies/AssembliesList";
import { v4 as uuidv4 } from "uuid";
import { ScreenWidth } from "src/stores/UIStore";
import { Tiles } from "src/components";
import { useHistory } from "react-router-dom";
import { Role } from "src/network/User";

interface Params {
    realestateid: string;
}

const ManagerAssembliesBase = (props: RouteComponentProps) => {
    const { t } = useTranslation();
    const history = useHistory();
    const { realestateid } = useParams<Params>();
    const { navStore, authStore, assemblyStore } = useContext(RootStoreContext);

    useEffect(() => {
        assemblyStore.loadAllAssemblies(realestateid, true);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        navStore.setBackbutton(
            selectRoute(Route.dashboard, authStore.user?.role, { realestateid: realestateid }),
            t("screens.realestate.dashboard.title")
        );
    }, [authStore.user?.role, realestateid, t, navStore]);

    const onClickNewAssemblyByRealestateId = useCallback(
        async (e: any) => {
            const fullRoute = Route.assemblyDetails.replace(":assemblyid", uuidv4()) + `?realestateId=${realestateid}`;
            const rolePath = authStore.user?.role ? `/${authStore.user.role}` : Role.MANAGER;
            history.push(rolePath + fullRoute);
        },
        [history, realestateid, authStore]
    );

    const contactTile = <Tiles.ContactTile realestateid={realestateid} />;

    return (
        <UI.Container className="pt-4">
            <UI.Title>{t("screens.realestate.assemblies.title")}</UI.Title>
            <UI.Row>
                <UI.Col xl={9}>
                    <UI.Card>
                        <UI.Button
                            className={styles.ManagerAddAssemblyButton}
                            label={t("screens.realestate.assemblies.create_assembly")}
                            onClick={onClickNewAssemblyByRealestateId}
                        />
                        <AssembliesList realestateId={realestateid} />
                    </UI.Card>
                </UI.Col>
                {window.innerWidth >= ScreenWidth.XL ? (
                    <UI.Col xl={3}>{contactTile}</UI.Col>
                ) : (
                    <UI.Col sm={12}>{contactTile}</UI.Col>
                )}
            </UI.Row>
        </UI.Container>
    );
};

export const ManagerAssemblies = withRouter(Sentry.withProfiler(observer(ManagerAssembliesBase)));
